<main id="externalUserCompId">
  <app-header></app-header>
  <app-announcement></app-announcement>
  <div #divCt class="fluid-container blw_headermain">
      <!-- tab starts here -->
      <div class="row">
          <div class="col-12 internal_main" id="exTab1">
              <!-- Nav buttons row -->
              <div class="row">
                  <div class="col-12">
                      <ul class="nav nav-pills nav_main" role="tablist">
                          <li class="nav-item" id="id1">
                              <a class="nav-link"
                                  [ngClass]="(hideOrderInvoice==true)?'OrderInvoice-hide':'OrderInvoice-unhide'"
                                  [class.active]="activeTab === 'invoice'"
                                  (click)="activeTab = 'invoice'; showInvoice()" role="tab">Invoice</a>
                          </li>
                          <li class="nav-item" id="id2">
                              <a class="nav-link"
                                  [ngClass]="(hideOrderInvoice==true)?'OrderInvoice-hide':'OrderInvoice-unhide'"
                                  [class.active]="activeTab === 'orders'" (click)="activeTab = 'orders'; OrdersTab()"
                                  role="tab">Orders</a>
                          </li>
                      </ul>
                  </div>
              </div>
              <div class="tab-content clearfix">
                  <div id="1a" *ngIf="activeTab === 'invoice'">
                      <!-- Search row -->
                      <div class="row">
                          <div class="col-12">
                              <div class="searchmain" [hidden]="!ShowInvoice">
                                  <div class="pull-left agencyCont">
                                      <p-autoComplete class="custom-agency custom-editagency"
                                          [inputStyle]="{ width: '280px' }" [(ngModel)]="newAgency"
                                          [emptyMessage]="'No Records Found'" [forceSelection]="true"
                                          (completeMethod)="agencyAutocompleteFilter($event)" [inputId]="'agency'"
                                          [placeholder]="'Type Agency'" name="agency" optionLabel="agencyName"
                                          dataKey="agencyID" (onClear)="clearInvoiceValue()" [minLength]="1"
                                          [suggestions]="agencyFilter" [dropdown]="false"
                                          [size]="30">
                                          <ng-template pTemplate="item" let-agency>
                                            {{ agency.agencyName }}
                                          </ng-template>
                                          <ng-template pTemplate="selectedItem" let-agency>
                                            {{ agency.agencyName }}
                                          </ng-template>
                                      </p-autoComplete>
                                      <button type="button" (click)="InvoiceDetail($event)"
                                          class="btn btn-success order_buttonicon">GO</button>
                                  </div>
                                  <input #gb type="text" placeholder="Search Alphanumeric values here..."
                                      class="search_box">
                                  <i class="fa fa-search search_icon"></i>
                              </div>
                          </div>
                      </div>
                      <!-- Table row -->
                      <div class="row">
                          <div class="col-12">
                              <div id="externalUserTable">
                                  <p-table #dt [hidden]="!ShowInvoice" [value]="Invoice"
                                      [ngClass]="{filter:enableInvoiceFilter}" [rows]="20" [paginator]="true"
                                      [pageLinks]="10" [globalFilterFields]="['invoiceID',
                                      'invoiceDate',
                                      'invoiceDateSortable',
                                      'agencyName',
                                      'invoiceDueDate',
                                      'invoiceDueDateSortable',
                                      'previousBalanceAmt',
                                      'invoiceAmount',
                                      'advertiserName',
                                      'advertiserId',
                                      'orderId',
                                      'estimateNumber',
                                      'propertyOrStationName',
                                      'createdDate',
                                      'chaseStatus',
                                      'status',
                                      'paymentTransType',
                                      'sapCompanyCode',
                                      'agencyCommission'
                                      ]"
                                      [reorderableColumns]="true" [resizableColumns]="false"
                                      [loading]="loadingInvoice" (onRowSelect)="onInvoiceRowSelect($event)"
                                      (onRowUnselect)="onRowInvoiceUnselect($event)"
                                      emptyMessage="No Invoice Available"
                                      (onHeaderCheckboxToggle)="invoiceHeaderCheckBoxToggle(selectedItems)"
                                      [(selection)]="selectedItems"
                                      [tableStyle]="{'table-layout':'inherit','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
                                      [responsiveLayout]="'scroll'">
                                      <ng-template pTemplate="header">
                                          <tr>
                                              <th style="width:38px;">
                                                  <i (click)="invoiceFilterToggle($event)"
                                                      class="fa fa-fw fa-filter cursorpointer"></i>
                                              </th>
                                              <!-- Arvind Station Name -->
                                              <th pSortableColumn="propertyOrStationName"
                                                  [ngStyle]="{'font-weight': 'bold'}">
                                                  Stations
                                                  <p-sortIcon field="propertyOrStationName"></p-sortIcon>
                                                  <p-columnFilter *ngIf="enableInvoiceFilter"
                                                      field="propertyOrStationName" display="menu"></p-columnFilter>
                                              </th>
                                              <!-- Invoice ID -->
                                              <th pSortableColumn="invoiceID" [ngStyle]="{'font-weight': 'bold'}">
                                                  Invoice ID
                                                  <p-sortIcon field="invoiceID"></p-sortIcon>
                                                  <p-columnFilter *ngIf="enableInvoiceFilter" field="invoiceID"
                                                      display="menu"></p-columnFilter>
                                              </th>
                                              <!-- Estimate Number -->
                                              <th pSortableColumn="estimateNumber"
                                                  [ngStyle]="{'font-weight': 'bold'}">
                                                  Estimate Number
                                                  <p-sortIcon field="estimateNumber"></p-sortIcon>
                                                  <p-columnFilter *ngIf="enableInvoiceFilter" field="estimateNumber"
                                                      display="menu"></p-columnFilter>
                                              </th>
                                              <!-- Invoice Date -->
                                              <th pSortableColumn="invoiceDateSortable"
                                                  [ngStyle]="{'font-weight': 'bold'}">
                                                  Invoice Date
                                                  <p-sortIcon field="invoiceDateSortable"></p-sortIcon>
                                                  <p-columnFilter *ngIf="enableInvoiceFilter"
                                                      field="invoiceDateSortable" display="menu">
                                                      <ng-template pTemplate="filter" let-value
                                                          let-filter="filterCallback">
                                                          <input type="text" class="form-control dateRangeFilter"
                                                              (bsValueChange)="dt.filter($event, 'invoiceDateSortable', 'inv_invDate')"
                                                              bsDaterangepicker
                                                              [bsConfig]="{ containerClass : 'theme-dark-blue' }">
                                                      </ng-template>
                                                  </p-columnFilter>
                                              </th>

                                              <!-- Agency Name -->
                                              <th pSortableColumn="agencyName" [ngStyle]="{'font-weight': 'bold'}">
                                                  Agency
                                                  <p-sortIcon field="agencyName"></p-sortIcon>
                                                  <p-columnFilter *ngIf="enableInvoiceFilter" field="agencyName"
                                                      display="menu"></p-columnFilter>
                                              </th>
                                              <!-- Advertiser Name -->
                                              <th pSortableColumn="advertiserName"
                                                  [ngStyle]="{'font-weight': 'bold'}">
                                                  Advertiser
                                                  <p-sortIcon field="advertiserName"></p-sortIcon>
                                                  <p-columnFilter *ngIf="enableInvoiceFilter" field="advertiserName"
                                                      display="menu"></p-columnFilter>
                                              </th>
                                              <!-- Invoice Due Date -->
                                              <th pSortableColumn="invoiceDueDateSortable"
                                                  [ngStyle]="{'font-weight': 'bold'}">
                                                  Due Date
                                                  <p-sortIcon field="invoiceDueDateSortable"></p-sortIcon>
                                                  <p-columnFilter *ngIf="enableInvoiceFilter"
                                                      field="invoiceDueDateSortable" display="menu">
                                                      <ng-template pTemplate="filter" let-value
                                                          let-filter="filterCallback">
                                                          <input type="text" class="form-control dateRangeFilter"
                                                              (bsValueChange)="dt.filter($event, 'invoiceDueDateSortable', 'inv_dueDate')"
                                                              bsDaterangepicker
                                                              [bsConfig]="{ containerClass : 'theme-dark-blue' }">
                                                      </ng-template>
                                                  </p-columnFilter>
                                              </th>
                                              <!-- Previous Balance Amount -->
                                              <th [ngStyle]="{'font-weight': 'bold', 'width': '200px'}">
                                                  <span>Prev. Balance<br /> (Cash Discount Price) $</span>
                                                  <p-columnFilter *ngIf="enableInvoiceFilter"
                                                      field="previousBalanceAmt" display="menu"></p-columnFilter>
                                              </th>
                                              <!--Payment Status-->
                                              <th pSortableColumn="invoiceDueDateSortable"
                                                  [ngStyle]="{'font-weight': 'bold'}">Payment Status</th>
                                              <th></th>
                                          </tr>
                                      </ng-template>
                                      <ng-template pTemplate="body" let-invoice>
                                          <tr [pSelectableRow]="invoice">
                                              <td>
                                                  <p-tableCheckbox [value]="invoice"></p-tableCheckbox>
                                              </td>
                                              <td>{{invoice.propertyOrStationName}}</td>
                                              <td>{{invoice.invoiceID}}</td>
                                              <td>{{invoice.estimateNumber}}</td>
                                              <td>{{invoice.invoiceDate}}</td>
                                              <td>{{invoice.agencyName}}</td>
                                              <td>{{invoice.advertiserName}}</td>
                                              <td>{{invoice.invoiceDueDate}}</td>
                                              <td>
                                                  <div style="text-align: right; padding-right: 20px;">
                                                      {{invoice.previousBalanceAmt | currency:'USD'}}
                                                  </div>
                                              </td>
                                              <td>
                                                  <div *ngIf="invoice.status=='Payment Processing'">
                                                      <img src="/assets/images/processing.png"
                                                          matTooltip="Payment Processing" />
                                                  </div>
                                              </td>

                                              <!-- PDF -->
                                              <td style="text-align:right;width: 40px !important">
                                                  <span class="pdfLink" matTooltip="Preview"
                                                      (click)="viewFile(invoice.invoiceID)">
                                                      <i class="fa fa-file-pdf-o pdf cursorpointer"></i>
                                                  </span>
                                              </td>
                                          </tr>
                                      </ng-template>
                                      <ng-template pTemplate="emptymessage">
                                          <tr>
                                              <td colspan="11" style="text-align: left;">No records found.</td>
                                          </tr>
                                      </ng-template>
                                  </p-table>
                              </div>
                          </div>
                      </div>
                  </div>
                  <!-- Invoice Tabs ends here -->
                  <!-- Orders tabs starts here -->
                  <div id="2a" *ngIf="activeTab === 'orders'">
                      <!-- Order Ptable start here  -->
                      <div id="externalUserTable2">
                          <div class="searchmain" [hidden]="!ShowOrder">
                              <div class="pull-left agencyCont">
                                  <p-autoComplete class="custom-agency custom-editagency"
                                      [inputStyle]="{'width':'280px','margin':'0px'}" [(ngModel)]="newAgency"
                                      [suggestions]="agencyFilter" emptyMessage="No Records Found"
                                      (completeMethod)="agencyAutocompleteFilter($event)" [size]="30" #agency
                                      placeholder="Type Agency" name="agency" optionLabel="agencyName" datakey="agencyID"
                                      (onClear)="clearOrderValue()" [minLength]="1">
                                      <ng-template pTemplate="item" let-agency>
                                        {{ agency.agencyName }}
                                      </ng-template>
                                      <ng-template pTemplate="selectedItem" let-agency>
                                        {{ agency.agencyName }}
                                      </ng-template>
                                  </p-autoComplete>

                                  <button type="button" (click)="OderDetail($event)"
                                      class="btn btn-success order_buttonicon">GO</button>
                              </div>

                              <input #ga type="text" placeholder="Search Alphanumeric values here..."
                                  class="search_box">
                              <i class="fa fa-search search_icon"></i>
                          </div>
                      </div>
                      <p-table [hidden]="!ShowOrder" [value]="Orders" [ngClass]="{filter:enableOrdersFilter}"
                          [loading]="loadingOrder" [rows]="20" [paginator]="true" [pageLinks]="10"
                          [globalFilterFields]="['invoiceID',
                          'invoiceDate',
                          'invoiceDateSortable',
                          'agencyName',
                          'invoiceDueDate',
                          'invoiceDueDateSortable',
                          'previousBalanceAmt',
                          'invoiceAmount',
                          'advertiserName',
                          'advertiserId',
                          'orderId',
                          'estimateNumber',
                          'propertyOrStationName',
                          'createdDate',
                          'chaseStatus',
                          'status',
                          'paymentTransType',
                          'sapCompanyCode',
                          'agencyCommission'
                          ]" #dtr [reorderableColumns]="true"
                          [resizableColumns]="true" emptyMessage="No Orders Available"
                          (onRowSelect)="onOrderRowSelect($event)" (onRowUnselect)="onRowOrderUnselect($event)"
                          [responsiveLayout]="'scroll'"
                          (onHeaderCheckboxToggle)="orderHeaderCheckBoxToggle(selectedOrderItems)"
                          [(selection)]="selectedOrderItems"
                          [tableStyle]="{'table-layout':'inherit','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}">
                          <ng-template pTemplate="header">
                              <tr>
                                  <th style="width:38px;">
                                      <i (click)="ordersFilterToggle($event)"
                                          class="fa fa-fw fa-filter cursorpointer"></i>
                                  </th>

                                  <!-- station -->
                                  <th pSortableColumn="station_name" [ngStyle]="{'font-weight': 'bold'}">
                                      Stations
                                      <p-sortIcon field="station_name"></p-sortIcon>
                                      <p-columnFilter *ngIf="enableOrdersFilter" field="station_name"
                                          display="menu"></p-columnFilter>
                                  </th>
                                  <!-- Order ID -->
                                  <th pSortableColumn="order_id" [ngStyle]="{'font-weight': 'bold'}">
                                      Order ID
                                      <p-sortIcon field="order_id"></p-sortIcon>
                                      <p-columnFilter *ngIf="enableOrdersFilter" field="order_id"
                                          display="menu"></p-columnFilter>
                                  </th>

                                  <!-- Order Date -->
                                  <th pSortableColumn="flight_start_dt_sortable" [ngStyle]="{'font-weight': 'bold'}">
                                      Flight Start Date
                                      <p-sortIcon field="flight_start_dt_sortable"></p-sortIcon>
                                      <p-columnFilter *ngIf="enableOrdersFilter" field="flight_start_dt_sortable"
                                          display="menu">
                                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                              <input type="text" class="form-control dateRangeFilter"
                                                  (bsValueChange)="dtr.filter($event, 'flight_start_dt_sortable', 'ord_ordDate')"
                                                  bsDaterangepicker
                                                  [bsConfig]="{ containerClass : 'theme-dark-blue' }">
                                          </ng-template>
                                      </p-columnFilter>
                                  </th>
                                  <!-- Agency -->
                                  <th pSortableColumn="agencyName" [ngStyle]="{'font-weight': 'bold'}">
                                      Agency
                                      <p-sortIcon field="agencyName"></p-sortIcon>
                                      <p-columnFilter *ngIf="enableOrdersFilter" field="agencyName"
                                          display="menu"></p-columnFilter>
                                  </th>
                                  <!-- Advertiser -->
                                  <th pSortableColumn="advertiser_name" [ngStyle]="{'font-weight': 'bold'}">
                                      Advertiser
                                      <p-sortIcon field="advertiser_name"></p-sortIcon>
                                      <p-columnFilter *ngIf="enableOrdersFilter" field="advertiser_name"
                                          display="menu"></p-columnFilter>
                                  </th>
                                  <!-- Order Total -->
                                  <th [ngStyle]="{'font-weight': 'bold', 'width': '175px'}">
                                      <span>Order Total<br /> (Cash Discount Price) $</span>
                                      <p-columnFilter *ngIf="enableOrdersFilter" field="total_order_amount"
                                          display="menu"></p-columnFilter>
                                  </th>
                                  <th></th>
                              </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-row>
                              <tr>
                                  <td>
                                      <p-tableCheckbox [value]="row"></p-tableCheckbox>
                                  </td>
                                  <td>{{row.station_name}}</td>
                                  <td>{{row.order_id}}</td>
                                  <td>{{row.flight_start_dt}}</td>
                                  <td>{{row.agencyName}}</td>
                                  <td>{{row.advertiser_name}}</td>
                                  <td style="text-align: right; padding-right: 20px;">{{row.total_order_amount |
                                      currency:'USD'}}</td>
                                  <!-- PDF -->
                                  <td style="text-align:right;width: 80px !important">
                                      <span class="pdfLink" matTooltip="Preview" (click)="viewFile(row.order_id)">
                                          <i class="fa fa-file-pdf-o pdf cursorpointer"></i>
                                      </span>
                                  </td>
                              </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                              <tr>
                                  <td style="text-align: left;">No records found.</td>
                              </tr>
                          </ng-template>
                      </p-table>

                  </div>
                  <!-- Orders tabs ends here -->
              </div>
          </div>
      </div>
  </div>
</main>



<div class="modal fade invoiceDetailModal" id="myModal" role="dialog">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal">&times;</button>
              <h5 class="modal-title">Invoice Detail of Order ID {{OrderRelatedInvoiceId}}</h5>
          </div>
          <div class="modal-body" *ngIf="IsinvoicedFlag == true">
              <div>
                  <p-table class="tableFixed" #dordert [value]="OrderInvoice" [rows]="8" [paginator]="true"
                      [pageLinks]="10" [editable]="true"
                      [globalFilterFields]="['propertyOrStationName','invoiceID','estimateNumber','invoiceDateSortable','agencyName','advertiserName','invoiceDueDateSortable','previousBalanceAmt','invoiceAmount','status']"
                      [reorderableColumns]="true" [resizableColumns]="false" [loading]="loadingOrderInvoicepopup"
                      (onRowSelect)="onOrderInvoiceRowSelect($event)"
                      (onRowUnselect)="onRowOrderInvoiceUnselect($event)"
                      (onHeaderCheckboxToggle)="orderInvoiceHeaderCheckBoxToggle(selectedItems)"
                      [(selection)]="selectedItems"
                      [tableStyle]="{'width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
                      [responsiveLayout]="'scroll'" emptyMessage="No Invoice Available">
                      <ng-template pTemplate="header">
                          <tr>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;">Stations</th>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;width:142px;">Invoice
                                  ID</th>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;">Estimate Number</th>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;width:150px;">Invoice
                                  Date</th>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;width:255px;">Agency
                              </th>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;width:255px;">
                                  Advertiser</th>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;width:116px;">Due Date
                              </th>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;">
                                  <span>Prev. Balance<br /> (Cash Discount Price) $</span>
                              </th>
                              <th pResizableColumn pReorderableColumn style="font-weight: bold;">
                                  <span>Invoice Total<br /> (Cash Disc. Price) $</span>
                              </th>
                              <th pResizableColumn pReorderableColumn style="font-weight: 900;">Payment Status</th>
                              <th pResizableColumn pReorderableColumn style="width:70px;"></th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-row>
                          <tr>
                              <td>{{row.propertyOrStationName}}</td>
                              <td>{{row.invoiceID}}</td>
                              <td>{{row.estimateNumber}}</td>
                              <td>{{row.invoiceDate}}</td>
                              <td>{{row.agencyName}}</td>
                              <td>{{row.advertiserName}}</td>
                              <td>{{row.invoiceDueDate}}</td>
                              <td style="text-align: right; padding-right: 15px;">{{row.previousBalanceAmt |
                                  currency:'USD'}}</td>
                              <td style="text-align: right;">{{row.invoiceAmount | currency:'USD'}}</td>
                              <td>
                                  <div *ngIf="row.status=='Payment Processing'">
                                      <img src="/assets/images/processing.png" matTooltip="Payment Processing" />
                                  </div>
                              </td>
                              <td style="text-align:right;width: 40px !important">
                                  <span class="pdfLink" matTooltip="Preview" (click)="viewFile(row.invoiceID)">
                                      <i class="fa fa-file-pdf-o pdf cursorpointer"></i>
                                  </span>
                              </td>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                          <tr>
                              <td colspan="11" style="text-align: left;">No Invoice Available</td>
                          </tr>
                      </ng-template>
                  </p-table>
              </div>
              <div class="pay_now">
              </div>
          </div>
          <div class="modal-body" *ngIf="IsinvoicedFlag == false" style="color: red">
              No Invoice Available
          </div>
      </div>
  </div>
</div>
<!-- Popup End  -->


<!-- PDF Popup -->
<p-dialog header="PDF" class="InvoicePDF" [(visible)]="display" modal="modal" [responsive]="true" [width]="800"
  [blockScroll]="true">
  <div *ngIf="showIframe">
      <iframe width="100%" height="500" [src]="urlSafe"></iframe>
  </div>

  <div *ngIf="fileNotFound">
      <label>File Not Found!</label>
  </div>

  <div id="fileLoader" *ngIf="fileLoading">
      <!-- <label>File loading! Please wait!</label> -->
      <p-progressSpinner [style]="{width: '70px', height: '70px'}"></p-progressSpinner>
  </div>

</p-dialog>